<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  async created (){
    window.addEventListener('resize', this.handleWindowResize)
    // window.addEventListener('scroll', this.handleScroll)
  },
  computed:{
    isIdle() {

			return this.$store.state.idleVue.isIdle;

		}
  },
  onIdle() {
    console.log('ZZZ')
    if (this.$store.state.auth.user !== null) {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }
  },
  mounted () {
     this.updatedWidth(window.innerWidth)
  },
  methods: {
    ...mapActions([
      'updatedWidth'
    ]),
    handleWindowResize () {
      this.updatedWidth(window.innerWidth)
    }
  }
}
</script>